import { useLang } from "@/i18n/LanguageContext";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQ = () => {
  const { t } = useLang();
  const items = t("faq.items");

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative bg-[#0e0e0e] py-24 md:py-32 border-t border-[#1f1f1f]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-px bg-[#dc2626]" />
              <p className="font-mono text-xs tracking-[0.3em] uppercase text-[#dc2626]">
                {t("faq.tag")}
              </p>
            </div>
            <h2 className="font-display font-black uppercase tracking-tighter text-3xl md:text-5xl leading-[0.95]">
              {t("faq.heading")}
            </h2>
          </div>

          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="w-full">
              {items.map((q, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border-b border-[#1f1f1f]"
                >
                  <AccordionTrigger className="text-left py-6 hover:no-underline hover:text-[#dc2626] transition-colors">
                    <span className="flex items-baseline gap-4">
                      <span className="font-mono text-[10px] text-[#52525b] tracking-[0.2em]">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <span className="font-display font-bold uppercase tracking-tight text-base md:text-lg">
                        {q.q}
                      </span>
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="text-[#a1a1aa] text-sm md:text-base leading-relaxed pb-6 pl-12">
                    {q.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
